import React, { useEffect, useState } from "react";
import LeaveRejoinPopup from "./LeaveRejoinPopup";
import { AiOutlineNodeExpand } from "react-icons/ai";
import { base_url } from "../../../utils/AxiosConfig";
import ReplayIcon from "@mui/icons-material/Replay";
import LoginIcon from "@mui/icons-material/Login";
import UndoIcon from "@mui/icons-material/Undo";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";

import axios from "axios";

const LeaveRejoin = () => {
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  const [Open, setOpen] = useState(false);
  const [DataApproved, setDataApproved] = useState();

  const [PopUpData, setPopUpData] = useState();
  const [rejoinPopupOpen, setRejoinPopupOpen] = useState(false);

  // pagination
  // const [currentPage, SetcurrentPage] = useState(1);
  const [currentPageApproved, SetcurrentPageApproved] = useState(1);
  // const [currentPageRejected, SetcurrentPageRejected] = useState(1);
  // const recordsPerPage = 10;
  const recordsPerPage = 15;

  // const lastIndex = currentPage * recordsPerPage;
  // const firstIndex = lastIndex - recordsPerPage;

  const lastIndexApproved = currentPageApproved * recordsPerPage;
  const firstIndexApproved = lastIndexApproved - recordsPerPage;

  const dataApprovedrecords = DataApproved?.slice(
    firstIndexApproved,
    lastIndexApproved,
  );

  const npageApproved = Math.ceil(DataApproved?.length / recordsPerPage);

  const numbersApproved = Array.from(
    { length: npageApproved },
    (_, i) => i + 1,
  );

  // approved
  function prePageApproved() {
    if (currentPageApproved !== firstIndexApproved) {
      SetcurrentPageApproved(currentPageApproved - 1);
    }
  }

  function changeCPageApproved(id) {
    SetcurrentPageApproved(id);
  }

  function nextPageApproved() {
    if (currentPageApproved !== lastIndexApproved) {
      SetcurrentPageApproved(currentPageApproved + 1);
    }
  }

  const getDataApproved = async () => {
    console.log(
      ` getDataApprovedApi - ${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/APPROVED/-`,
    );
    const response = await axios.get(
      `${base_url}/api/PersonalInfoLeaveApplicationList/${companyCode}/APPROVED/-`,
    );
    if (response?.data) {
      setDataApproved(response.data);
    } else {
      console.log("error");
    }
  };

  useEffect(() => {
    getDataApproved();
  }, []);

  return (
    <div>
      {/* <div
        className={
          Open
            ? "leave-allotment container ps-2 expand-scroll"
            : "container ps-2 scroll"
        }
      > */}
      <div className="">
        <div className="row">
          {/* <div className="col-6">
            <h6 className="mb-4 text-2xl font-bold text-gray-600 flex  justify-start items-center">

              <span>Leave Rejoin</span>
            </h6>
          </div> */}
          <div className="flex justify-left items-center">
            <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
            <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4">
              <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
                LEAVE REJOIN
              </span>
            </h6>
          </div>
          {/* <div className="col-6 text-end">
            <AiOutlineNodeExpand
              className="fs-big"
              onClick={() => setOpen(Open === true ? false : true)}
            />
          </div> */}
        </div>
        <p className="text-gray-700 text-xs font-normal mt-3 mb-1">
          Approved Leave
        </p>
        <table className="shadow-sm min-w-full bg-white rounded-sm border border-gray-300 text-xs ">
          <thead>
            <tr className="bg-[#2663EB] text-white">
              <th className="px-2 py-1 border-none font-normal">Sl No</th>
              <th className="px-2 py-1 border-none font-normal">Name</th>
              <th className="px-2 py-1 border-none font-normal">Leave Type</th>
              <th className="px-2 py-1 border-none font-normal">
                Application Date
              </th>
              <th className="px-2 py-1 border-none font-normal">Leave from</th>
              <th className="px-2 py-1 border-none font-normal">Leave To</th>
              <th className="px-2 py-1 border-none font-normal">Total Days</th>
              <th className="px-2 py-1 border-none font-normal">Notes</th>
              <th className="px-2 py-1 border-none font-normal">Ticket</th>
              <th className="px-2 py-1 border-none font-normal">
                Approval Status
              </th>
              <th className="px-2 py-1 border-none font-normal text-center">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {dataApprovedrecords
              ? dataApprovedrecords?.map((d, i) => (
                  <tr className="">
                    <td className="px-2 py-1 border">{i + 1}</td>
                    <td className="px-2 py-1 border">{d.Name}</td>
                    <td className="px-2 py-1 border">{d.Leave_Category}</td>
                    <td className="px-2 py-1 border">
                      {d.ApplicationDate.split("T")[0]}
                    </td>
                    <td className="px-2 py-1 border">
                      {d.FromDate.split("T")[0]}
                    </td>
                    <td className="px-2 py-1 border">
                      {d.ToDate.split("T")[0]}
                    </td>
                    <td className="px-2 py-1 border">{d.Days}</td>
                    <td className="px-2 py-1 border">{d.approvalnote}</td>
                    {/* <td className="px-2 py-1 border"><input type="text" className="form-control"/></td> */}
                    <td className="px-2 py-1 border">{d.Ticket}</td>
                    <td className="px-2 py-1 border">{d.ApprovalStatus}</td>

                    <td className="text-center border">
                      <button
                        // className="dash-btn"
                        className="bg-green-500 px-2 py-1 border rounded-lg text-white font-semibold"
                        // data-bs-toggle="modal"
                        // data-bs-target="#exampleModal"

                        onClick={() => {
                          setPopUpData(d);
                          setRejoinPopupOpen(true);
                        }}
                      >
                        Rejoin
                        {/* <ReplayIcon /> */}
                        {/* <LoginIcon className="mr-1" /> */}
                        {/* <UndoIcon className="mr-1" /> */}
                        {/* <PublishedWithChangesIcon className="h-1 w-1" /> */}
                      </button>
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </table>
      </div>

      {dataApprovedrecords ? (
        <>
          <div className="pagination-div">
            <div className="mt-4">
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <li class="page-item">
                    {currentPageApproved !== 1 ? (
                      <button
                        class="page-link"
                        href="#"
                        onClick={prePageApproved}
                      >
                        Previous
                      </button>
                    ) : (
                      ""
                    )}
                  </li>
                  {numbersApproved.map((n, i) => (
                    <li
                      className={`page-item ${
                        currentPageApproved === n ? "active" : ""
                      }`}
                      key={i}
                    >
                      <button
                        className="page-link"
                        onClick={() => changeCPageApproved(n)}
                        href="#"
                      >
                        {n}
                      </button>
                    </li>
                  ))}

                  <li class="page-item">
                    {currentPageApproved !==
                    numbersApproved[numbersApproved.length - 1] ? (
                      <button
                        class="page-link"
                        href="#"
                        onClick={nextPageApproved}
                      >
                        Next
                      </button>
                    ) : (
                      ""
                    )}
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </>
      ) : null}
      {/* 
      <div className="leave-application-table mt-2 container-fluid">
        <p className="fs-small text-secondary">Recent Rejoin</p>
        <table class="table table-striped border ">
          <tbody>
            <tr className="table-primary">
              <td>Si No</td>
              <td>Leave Type</td>
              <td>Apl DT</td>
              <td>From Dt</td>
              <td>To Dt</td>
              <td>Leaves </td>
              <td>Notes</td>
              <td>Ticket</td>
              <td>Status</td>
              <td></td>
            </tr>

            <tr>
              <td>1</td>
              <td>Annual Leave</td>
              <td>04/09/2022</td>
              <td>01/10/2022</td>
              <td>16</td>
              <td>-</td>
              <td>Approved</td>
              <td></td>
              <td>Joined</td>
            </tr>
          </tbody>
        </table>
      </div> */}
      {rejoinPopupOpen && (
        <LeaveRejoinPopup
          setPopUpData={setPopUpData}
          PopUpData={PopUpData}
          getDataApproved={getDataApproved}
          onClose={() => setRejoinPopupOpen(false)}
        />
      )}
    </div>
  );
};

export default LeaveRejoin;
